import { Routes } from '@angular/router';

export const routes: Routes = [
    // KYC Form
    {
        path: 'margin',
        loadChildren: () =>
            import('./features/margin/margin.routes').then((m) => m.routes),
    },
    // Home redirect
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'margin',
    },
    // Thank you page
    {
        path: 'thank-you',
        loadComponent: () =>
            import(
                './shared/components/request-success/request-success.component'
            ).then((m) => m.RequestSuccessComponent),
    },
    // Invalid link page
    {
        path: 'invalid-link',
        loadComponent: () =>
            import('./shared/components/invalid-route/invalid-route.component').then(
                (m) => m.InvalidRouteComponent
            ),
    },
    // Catch all - show invalid route error
    {
        path: '**',
        loadComponent: () =>
            import('./shared/components/invalid-route/invalid-route.component').then(
                (m) => m.InvalidRouteComponent
            ),
    },
];
